export default __webpack_public_path__ + "static/media/full_compatibility_icon.411faf40.svg";